import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { WeekappLogo } from '../components/ui/WeekappLogo';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="mb-8 opacity-50">
        <WeekappLogo variant="icon" colorScheme="blue" width={120} />
      </div>
      <h1 className="text-6xl font-bold text-muted-foreground mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Страница не найдена</h2>
      <p className="text-muted-foreground mb-6">
        Страница, которую вы ищете, не существует.
      </p>
      <Button asChild>
        <Link to="/">Вернуться на главную</Link>
      </Button>
    </div>
  );
}